import React from "react";
import Contact from "../components/Contact";

export default function ContactPage() {
  return (
    <>
      <section className="py-20 md:py-28 bg-jk-cream border-b border-[#e7e2d7]">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <div className="text-[11px] tracking-[0.32em] text-[#b88b4a] mb-5">CONTACT</div>
          <h1 className="font-serif text-neutral-900 text-[44px] md:text-[76px] leading-[1.03] tracking-tight max-w-5xl">
            Let&apos;s find your <span className="italic">next address.</span>
          </h1>
          <p className="mt-7 text-neutral-700 text-[16px] md:text-[18px] leading-[1.85] max-w-3xl">
            Call, WhatsApp or send us a message. We respond to every enquiry within 2 working hours.
          </p>
        </div>
      </section>

      <Contact />
    </>
  );
}
